import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=0b9044fc&scoped=true"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9044fc",
  null
  
)

export default component.exports